import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  AppBar,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../AxiosBaseApi";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FooterNav from "./FooterNav";

const PersonalDetail = () => {
  const history = useNavigate();
  const [data, SetData] = useState([]);
  
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=getuserinfo&user=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            SetData(res.data);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      history("/login");
    } else {
      getUserData(token);
    }
  }, []);

  return (
    <>
      <div style={{ width: "100%" }}>
        <Box sx={{ marginBottom: "5px" }}>
          <AppBar
            position="static"
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "2px 10px",
              height: "3.22667rem",
              boxShadow: "unset",
              background: "#3d3b6f",
            }}
          >
            <Box onClick={() => history(-1)} style={{ textDecoration: "none" }}>
              <ChevronLeftIcon
                fontSize="medium"
                style={{
                  // width: "60px",
                  color: "#fff",
                  border: "1px solid #f2f3f5",
                  borderRadius: 50,
                }}
              />
            </Box>
            <Typography style={{ color: "#fff", fontSize: "18px" }}>
              Personal Information
            </Typography>

            <Box></Box>
          </AppBar>
        </Box>
        <Box style={{ width:"100%", display:'flex', justifyContent:"center"}}>

        
        <Card
          sx={{ maxWidth: 345, height: "300px", borderRadius: 3, boxShadow: 3 }}
        >
          <CardContent>
            <Typography
              variant="h5"
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              Personal Information
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  <strong>Nick Name:</strong> {data[0]?.nickname}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  <strong>User Name:</strong> {data[0]?.username}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  <strong>Balance:</strong> {data[0]?.balance}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  <strong>Id:</strong> {data[0]?.id}
                </Typography>
              </Grid>
           
            </Grid>
          </CardContent>
        </Card>
        </Box>
      </div>
      <FooterNav />
    </>
  );
};

export default PersonalDetail;
